<script>
/**
 * Aviso fixo dos resultados APVS Truck: a APVS faz tratativas internas no fechamento
 * (ex.: desmembramento de contrato) que entram como adesão e depois são retiradas.
 * Usado em Minhas Metas, na Jornada diária e na Minha Jornada.
 */
export default {
  name: "AvisoTruck",
  props: {
    compacto: { type: Boolean, default: false },
  },
};
</script>

<template>
  <div class="aviso-truck" :class="{ compacto }" role="note">
    <i class="bx bx-error" aria-hidden="true"></i>
    <p class="mb-0">
      <strong>Atenção aos resultados da APVS Truck:</strong> os dados podem sofrer alterações no fechamento.
      Existem tratativas internas da APVS, como o desmembramento de contrato, que chegam como adesões e acabam
      contando para a sua meta, mas no fechamento a APVS retira essas placas. Tenha bastante cuidado com estes
      resultados, pois não temos o gerenciamento completo delas.
    </p>
  </div>
</template>

<style scoped>
.aviso-truck {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.625rem 0.875rem;
  border-radius: var(--st-radius);
  background: var(--st-warning-soft);
  color: var(--st-warning-strong);
  font-size: 0.875rem;
  line-height: 1.4;
}
.aviso-truck i {
  flex: 0 0 auto;
  margin-top: 0.125rem;
  font-size: 1.125rem;
}
.aviso-truck.compacto {
  margin-bottom: 0.75rem;
  font-size: 0.75rem;
}
</style>
